import { WebSocketMessage } from "model/WebSocketMessage";
import { MessageOpcode } from "types/MessageOpcode";
import {
  DyscalculiaResultItem,
  DyscalculiaSnapshot,
  DyscalculiaTaskType,
  MagnitudeComparisonResult,
} from "types/tests/specifics";

const normalizeTaskType = (value: unknown): DyscalculiaTaskType | undefined => {
  if (typeof value !== "string") return undefined;
  const map: Record<string, DyscalculiaTaskType> = {
    magnitudeSymbolic: "magnitudeComparisonSymbolic",
    magnitudeComparisonSymbolic: "magnitudeComparisonSymbolic",
    magnitudeNonSymbolic: "magnitudeComparisonNonSymbolic",
    magnitudeComparisonNonSymbolic: "magnitudeComparisonNonSymbolic",
    stroop: "stroop",
    numberLine: "numberLine",
    dotEnumeration: "dotEnumeration",
  };
  return map[value];
};

export const parseDyscalculiaSnapshot = (
  opCode: number,
  msg: WebSocketMessage,
): DyscalculiaSnapshot | undefined => {
  if (opCode !== MessageOpcode.DYSCALCULIA_TEST_UPDATE) {
    return undefined;
  }

  const taskType = normalizeTaskType(msg["snapshotType"]);
  const rawSnapshot = msg["snapshot"];

  if (!taskType || !rawSnapshot) {
    return undefined;
  }

  let parsedSnapshot: DyscalculiaResultItem | null = null;

  try {
    parsedSnapshot =
      typeof rawSnapshot === "string"
        ? (JSON.parse(rawSnapshot) as DyscalculiaResultItem)
        : rawSnapshot;
  } catch (error) {
    console.error("Failed to parse dyscalculia snapshot", error);
    return undefined;
  }

  if (taskType === "magnitudeComparisonSymbolic" || taskType === "magnitudeComparisonNonSymbolic") {
    (parsedSnapshot as MagnitudeComparisonResult).isSymbolic =
      taskType === "magnitudeComparisonSymbolic";
  }

  const taskId = typeof msg["taskId"] === "string" ? msg["taskId"] : undefined;

  return { taskType, taskId, result: parsedSnapshot as DyscalculiaResultItem };
};
